//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        name: {
            required: true,
            type: String
        },
        bgPath: {
            required: true,
            type: String
        },
        bubbleText: {
            required: true,
            type: String
        }
    },

    data () {
        return {
            show: false
        };
    },

    computed: {
        avatar () {
            return this.$store.getters.avatar;
        },
        badge () {
            return this.$store.getters.getBadge(this.name);
        }
    },

    created () {
        if (this.$store.getters.hasUserFinishedWeek(this.$route.meta.week) ||
            !this.$store.getters.deservesUserBadge(...this.badge.game)) {
            this.$router.push({ name: 'next' });
            return;
        }

        this.show = true;
        this.store();
    },

    methods: {
        store () {
            axios.post('game/badge', {
                name: this.badge.name,
                week: this.badge.week,
                day: this.badge.day
            }).then(response => {
                this.$store.commit('storeGameData', response.data.data);
            }).catch(() => {});
        }
    }
};
